export const BadgeLeft = { borderTopRightRadius: 0, borderBottomRightRadius: 0 };
export const BadgeRight = { borderTopLeftRadius: 0, borderBottomLeftRadius: 0 };
